module.exports = __webpack_public_path__ + "9159de645b7ac3ad4538d6332d05dba7.svg";